import { FILTER_V2_IDS, ORDER_STATUS } from "./Constants";
import { fp, spH, spV, wp } from "./normalizeV2";

import ImageView from "../image";
import { Images } from "../assets/index";
import VText from "components/VText";
import { View } from "react-native";
import moment from "moment";

export function debounce(func, delay) {
    let timeoutId;

    return function (...args) {
        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

const getFormatedDate = (date, dateFormat = "Do MMM YYYY") => {
    if (date) {
        return moment(date).format(dateFormat);
    } else {
        return null;
    }
};

const getFormatedCurrency = (num) => {
    try {
        return new Intl.NumberFormat("en-US", {
            maximumSignificantDigits: 10,
        }).format(Number(num));
    } catch (err) {
        return 0;
    }
};

const getChartValueFromArr = (arr = [], value = 0, key = "totalEarnings") => {
    try {
        if (arr && Array.isArray(arr)) {
            let temp = arr?.map((o) => o?.[key]);
            let hightestChartValue = Math.max(...temp);
            let chartValue = 0;
            if (hightestChartValue) {
                chartValue = (value / hightestChartValue) * 100;
            }
            return chartValue;
        } else {
            return 0;
        }
    } catch (err) {
        console.log("err", err);
        return 0;
    }
};

const getOrderHistoryCardView = (status = "", productDetails = {}, isAffiliate = false, isMarkDown = true) => {
    switch (status) {
        case ORDER_STATUS.NOT_INITIATED:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <View style={{ width: "100%" }}>
                        <VText
                            style={{
                                color: "#C0740A",
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                    </View>
                </View>
            );

        case ORDER_STATUS.PAYMENT_PROCESING:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <View style={{ width: "100%" }}>
                        <VText
                            style={{
                                color: "#C0740A",
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                    </View>
                </View>
            );

        case ORDER_STATUS.PAYMENT_FAILED:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <View style={{ width: "100%" }}>
                        <VText
                            style={{
                                color: "#D02C2C",
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                    </View>
                </View>
            );

        case ORDER_STATUS.PREPARING:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <ImageView
                        source={Images.preparing}
                        style={{
                            height: wp(24),
                            width: wp(24),
                        }}
                    />
                    <View style={{ marginLeft: spH(10), width: "100%" }}>
                        <VText
                            style={{
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                        {!isAffiliate && productDetails?.deliveryDate && (
                            <View
                                style={{
                                    marginTop: spV(5),
                                }}
                            >
                                {isMarkDown && (
                                    <VText
                                        style={{
                                            lineheight: wp(24),
                                            fontWeight: "350",
                                        }}
                                    >
                                        {productDetails?.isPreorder
                                            ? productDetails?.preorderMessage
                                            : `Arriving by ${moment(productDetails?.deliveryDate).format("Do MMM YY")}`}
                                    </VText>
                                )}
                                {!isMarkDown && (
                                    <VText
                                        style={{
                                            lineheight: wp(24),
                                            fontWeight: "350",
                                        }}
                                    >
                                        {productDetails?.isPreorder
                                            ? productDetails?.preorderMessage
                                            : `Arriving by ${moment(productDetails?.deliveryDate).format("Do MMM YY")}`}
                                    </VText>
                                )}
                            </View>
                        )}
                    </View>
                </View>
            );

        case ORDER_STATUS.BOUGHT_FROM_STORE:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <ImageView
                        source={Images.Web}
                        style={{
                            width: wp(24),
                            height: wp(24),
                        }}
                    />
                    <View style={{ marginLeft: spH(10), width: "100%" }}>
                        <VText
                            style={{
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                    </View>
                </View>
            );

        case ORDER_STATUS.OUT_FOR_DELIVERY:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <ImageView
                        source={Images.outForDelivery}
                        style={{
                            width: wp(24),
                            height: wp(24),
                        }}
                    />
                    <View style={{ marginLeft: spH(10), width: "100%" }}>
                        <VText
                            style={{
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                        {!isAffiliate && productDetails?.deliveryDate && (
                            <VText
                                style={{
                                    lineheight: wp(24),
                                    fontWeight: "350",
                                }}
                            >
                                {`Arriving by ${moment(productDetails?.deliveryDate).format("Do MMM YY")}`}
                            </VText>
                        )}
                    </View>
                </View>
            );

        case ORDER_STATUS.DELIVERED:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <ImageView
                        source={Images.delivered}
                        style={{
                            width: wp(24),
                            height: wp(24),
                        }}
                    />
                    <View style={{ marginLeft: spH(10), width: "100%" }}>
                        <VText
                            style={{
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                        {!isAffiliate && productDetails?.deliveryDate && (
                            <VText
                                style={{
                                    lineheight: wp(24),
                                    fontWeight: "350",
                                }}
                            >
                                {`On ${moment(productDetails?.deliveryDate).format("Do MMM YY")}`}
                            </VText>
                        )}
                    </View>
                </View>
            );

        case ORDER_STATUS.CANCELED:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <ImageView
                        source={Images.cancelled}
                        style={{
                            width: wp(24),
                            height: wp(24),
                        }}
                    />
                    <View style={{ marginLeft: spH(10), width: "100%" }}>
                        <VText
                            style={{
                                color: "#E64949",
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                        {!isAffiliate && productDetails?.cancelledDate && (
                            <VText
                                style={{
                                    lineheight: wp(24),
                                    fontWeight: "350",
                                }}
                            >
                                {`On ${moment(productDetails?.cancelledDate).format("Do MMM YY")}`}
                            </VText>
                        )}

                        {!isAffiliate && (productDetails?.refundCredited || productDetails?.refundInitiated) && (
                            <VText
                                style={{
                                    lineheight: wp(24),
                                    fontWeight: "350",
                                }}
                            >
                                <VText
                                    style={[
                                        {
                                            lineheight: wp(24),
                                            fontWeight: "350",
                                        },
                                        { color: "#169C00" },
                                    ]}
                                >
                                    {productDetails?.refundCredited ? "Refund Credited: " : "Refund Initiated: "}
                                </VText>
                                {`$${getFormatedCurrency(productDetails.refundAmount)} on ${getFormatedDate(
                                    productDetails?.redundCreditedDate || productDetails?.refundInitiatedDate
                                )}`}
                            </VText>
                        )}
                    </View>
                </View>
            );

        case ORDER_STATUS.RETURNED:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <ImageView
                        source={Images.returned}
                        style={{
                            width: wp(24),
                            height: wp(24),
                        }}
                    />

                    <View style={{ marginLeft: spH(10), width: "100%" }}>
                        <VText
                            style={{
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                        {!isAffiliate && productDetails?.returnedDate && (
                            <VText
                                style={{
                                    lineheight: wp(24),
                                    fontWeight: "350",
                                }}
                            >
                                {`On ${moment(productDetails?.returnedDate).format("Do MMM YY")}`}
                            </VText>
                        )}

                        {!isAffiliate && (productDetails?.refundCredited || productDetails?.refundInitiated) && (
                            <VText
                                style={{
                                    lineheight: wp(24),
                                    fontWeight: "350",
                                }}
                            >
                                <VText
                                    style={[
                                        {
                                            lineheight: wp(24),
                                            fontWeight: "350",
                                        },
                                        { color: "#169C00" },
                                    ]}
                                >
                                    {productDetails?.refundCredited ? "Refund Credited: " : "Refund Initiated: "}
                                </VText>
                                {`$${getFormatedCurrency(productDetails.refundAmount)} on ${getFormatedDate(
                                    productDetails?.redundCreditedDate || productDetails?.refundInitiatedDate
                                )}`}
                            </VText>
                        )}
                    </View>
                </View>
            );

        default:
            return (
                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                    <ImageView
                        source={Images.preparing}
                        style={{
                            height: wp(24),
                            width: wp(24),
                        }}
                    />

                    <View style={{ marginLeft: spH(10), width: "100%" }}>
                        <VText
                            style={{
                                fontWeight: "550",
                                fontSize: fp(14),
                            }}
                        >
                            {productDetails?.status}
                        </VText>
                        {!isAffiliate && productDetails?.returnedDate && (
                            <VText
                                style={{
                                    lineheight: wp(24),
                                    fontWeight: "350",
                                }}
                            >
                                {`Returned On ${moment(productDetails?.returnedDate).format("Do MMM YY")}`}
                            </VText>
                        )}

                        {!isAffiliate && (productDetails?.refundCredited || productDetails?.refundInitiated) && (
                            <VText
                                style={{
                                    lineheight: wp(24),
                                    fontWeight: "350",
                                }}
                            >
                                <VText
                                    style={[
                                        {
                                            lineheight: wp(24),
                                            fontWeight: "350",
                                        },
                                        { color: "#169C00" },
                                    ]}
                                >
                                    {productDetails?.refundCredited ? "Refund Credited: " : "Refund Initiated: "}
                                </VText>
                                {`$${getFormatedCurrency(productDetails.refundAmount)} on ${getFormatedDate(
                                    productDetails?.redundCreditedDate || productDetails?.refundInitiatedDate
                                )}`}
                            </VText>
                        )}
                    </View>
                </View>
            );
    }
};

const getOrderHistoryCardBottomView = (status = "") => {
    switch (status) {
        case ORDER_STATUS.NOT_INITIATED:
            return (
                <View style={{ flexDirection: "row", alignItems: "center", marginTop: spV(10) }}>
                    <ImageView
                        source={Images.infoGray}
                        style={{
                            height: wp(12),
                            width: wp(12),
                        }}
                    />
                    <VText
                        style={{
                            fontSize: fp(14),
                            fontWeight: "350",
                            color: "#2124274D",
                            marginLeft: spH(10),
                        }}
                    >
                        Failed amount will be refunded in the source account
                    </VText>
                </View>
            );

        case ORDER_STATUS.PAYMENT_PROCESING:
            return (
                <View style={{ flexDirection: "row", alignItems: "center", marginTop: spV(10) }}>
                    <ImageView
                        source={Images.infoGray}
                        style={{
                            height: wp(12),
                            width: wp(12),
                        }}
                    />
                    <VText
                        style={{
                            fontSize: fp(14),
                            fontWeight: "350",
                            color: "#2124274D",
                            marginLeft: spH(10),
                        }}
                    >
                        Failed amount will be refunded in the source account
                    </VText>
                </View>
            );

        case ORDER_STATUS.PAYMENT_FAILED:
            return (
                <View style={{ flexDirection: "row", alignItems: "center", marginTop: spV(10) }}>
                    <ImageView
                        source={Images.infoGray}
                        style={{
                            height: wp(12),
                            width: wp(12),
                        }}
                    />
                    <VText
                        style={{
                            fontSize: fp(14),
                            fontWeight: "350",
                            color: "#2124274D",
                            marginLeft: spH(10),
                        }}
                    >
                        If any amount got deducted it will be refunded in the source account
                    </VText>
                </View>
            );

        case ORDER_STATUS.PREPARING:
            return <></>;

        case ORDER_STATUS.BOUGHT_FROM_STORE:
            return <></>;

        case ORDER_STATUS.OUT_FOR_DELIVERY:
            return <></>;

        case ORDER_STATUS.DELIVERED:
            return <></>;

        case ORDER_STATUS.CANCELED:
            return <></>;

        case ORDER_STATUS.RETURNED:
            return <></>;

        default:
            return <></>;
    }
};

const getFilterParamsV2 = (data) => {
    return {
        brandIds: Array.isArray(data?.[FILTER_V2_IDS.BRAND]) ? data[FILTER_V2_IDS.BRAND]?.map((o) => o?.id) : [],
        color: Array.isArray(data?.[FILTER_V2_IDS.COLOR]) ? data[FILTER_V2_IDS.COLOR]?.map((o) => o?.title) : [],
        size: [
            ...(Array.isArray(data?.[FILTER_V2_IDS.BRA_SIZE])
                ? data[FILTER_V2_IDS.BRA_SIZE]?.map((o) => o?.title)
                : []),
            ...(Array.isArray(data?.[FILTER_V2_IDS.CLOTHING_SIZE])
                ? data[FILTER_V2_IDS.CLOTHING_SIZE]?.map((o) => o?.title)
                : []),
            ...(Array.isArray(data?.[FILTER_V2_IDS.SHOE_SIZE])
                ? data[FILTER_V2_IDS.SHOE_SIZE]?.map((o) => o?.title)
                : []),
        ],
        priceData: Array.isArray(data?.[FILTER_V2_IDS.PRICE]) ? data[FILTER_V2_IDS.PRICE]?.map((o) => o?.id) : [],
        categoryIds: [
            ...(Array.isArray(data?.[FILTER_V2_IDS.CATEGORY])
                ? data[FILTER_V2_IDS.CATEGORY]?.filter((o) => o?.isSubCategory)?.map((o) => o?.id)
                : []),
            ...(Array.isArray(data?.[FILTER_V2_IDS.SHOE_SIZE]) && data?.[FILTER_V2_IDS.SHOE_SIZE]?.length > 0
                ? [5]
                : []),
            ...(Array.isArray(data?.[FILTER_V2_IDS.CLOTHING_SIZE]) && data?.[FILTER_V2_IDS.CLOTHING_SIZE]?.length > 0
                ? [3]
                : []),
        ],
        subCategoryIds: Array.isArray(data?.[FILTER_V2_IDS.CATEGORY])
            ? data[FILTER_V2_IDS.CATEGORY]?.filter((o) => !o?.isSubCategory)?.map((o) => o?.id)
            : [],
        availability: Array.isArray(data?.[FILTER_V2_IDS.AVAILABILITY])
            ? data[FILTER_V2_IDS.AVAILABILITY]?.map((o) => o?.id)
            : [],
    };
};

const getFilterParamsAPIV2 = (data) => {
    return {
        categoryIds: [
            ...(Array.isArray(data?.[FILTER_V2_IDS.CATEGORY])
                ? data[FILTER_V2_IDS.CATEGORY]?.filter((o) => o?.subCategory)?.map((o) => o?.subCategory)
                : []),
            ...(Array.isArray(data?.[FILTER_V2_IDS.CATEGORY])
                ? data[FILTER_V2_IDS.CATEGORY]?.filter((o) => o?.isSubCategory)?.map((o) => o?.id)
                : []),
        ]
            .flat()
            .map((o) => {
                if (typeof o == "string") {
                    return o?.split(",")?.map((o) => Number(o));
                }
                return o;
            })
            .flat()
            ?.filter((o) => typeof o == "number"),
    };
};

const checkSelectedFilters = (data) => {
    // Iterate over each key in the object
    for (const key in data) {
        // Check if the value is an array and if it's empty
        if (Array.isArray(data?.[key]) && data?.[key]?.length === 0) {
            // Delete the key from the object if the value is an empty array
            delete data[key];
        }
    }
    return data; // Return the modified object
};

const getFilterUrlParams = (data) => {
    // console.log("getFilterUrlParams", data);
    const jsonString = JSON.stringify(data);
    const encodedData = encodeURIComponent(jsonString);

    // if (
    //   Array.isArray(data?.[FILTER_V2_IDS.BRAND]) &&
    //   data?.[FILTER_V2_IDS.BRAND]?.length > 0
    // ) {
    //   params.brandIds = data[FILTER_V2_IDS.BRAND]?.map((o) => o?.id);
    // }
    // if (
    //   Array.isArray(data?.[FILTER_V2_IDS.COLOR]) &&
    //   data?.[FILTER_V2_IDS.COLOR]?.length > 0
    // ) {
    //   params.color = data[FILTER_V2_IDS.COLOR]?.map((o) => o?.id);
    // }
    // if (
    //   Array.isArray(data?.[FILTER_V2_IDS.SIZE]) &&
    //   data?.[FILTER_V2_IDS.SIZE]?.length > 0
    // ) {
    //   params.size = data[FILTER_V2_IDS.SIZE]?.map((o) => o?.id);
    // }
    // if (
    //   Array.isArray(data?.[FILTER_V2_IDS.PRICE]) &&
    //   data?.[FILTER_V2_IDS.PRICE]?.length > 0
    // ) {
    //   params.priceData = data[FILTER_V2_IDS.PRICE]?.map((o) => o?.id);
    // }
    // if (
    //   Array.isArray(data?.[FILTER_V2_IDS.CATEGORY]) &&
    //   data?.[FILTER_V2_IDS.CATEGORY]?.length > 0 &&
    //   data[FILTER_V2_IDS.CATEGORY]?.filter((o) => o?.isSubCategory)?.length > 0
    // ) {
    //   params.categoryIds = data[FILTER_V2_IDS.CATEGORY]
    //     ?.filter((o) => o?.isSubCategory)
    //     ?.map((o) => o?.id);
    // }
    // if (
    //   Array.isArray(data?.[FILTER_V2_IDS.CATEGORY]) &&
    //   data?.[FILTER_V2_IDS.CATEGORY]?.length > 0 &&
    //   data[FILTER_V2_IDS.CATEGORY]?.filter((o) => !o?.isSubCategory)?.length > 0
    // ) {
    //   params.subCategoryIds = data[FILTER_V2_IDS.CATEGORY]
    //     ?.filter((o) => !o?.isSubCategory)
    //     ?.map((o) => o?.id);
    // }
    // if (
    //   Array.isArray(
    //     data?.[FILTER_V2_IDS.AVAILABILITY] &&
    //       data?.[FILTER_V2_IDS.AVAILABILITY]?.length > 0
    //   )
    // ) {
    //   params.availability = data[FILTER_V2_IDS.AVAILABILITY]?.map((o) => o?.id);
    // }

    return encodedData;
};

function removeObjectWithId(jsonData, idToRemove) {
    for (let key in jsonData) {
        if (Array.isArray(jsonData[key])) {
            jsonData[key] = jsonData[key]?.filter((item) => item.id !== idToRemove);
        } else if (typeof jsonData[key] === "object") {
            for (let innerKey in jsonData[key]) {
                if (Array.isArray(jsonData[key][innerKey])) {
                    jsonData[key][innerKey] = jsonData[key][innerKey]?.filter((item) => item.id !== idToRemove);
                }
            }
        }
    }
}

function stringToColor(str = "") {
    if (str && str?.length >= 2) {
        // Initialize hash to a prime number
        let hash = 5381;

        // Loop through each character in the string
        for (let i = 0; i < str.length; i++) {
            // Update the hash based on the Unicode code point of the character
            hash = (hash * 33) ^ str.charCodeAt(i);
        }

        // Convert the hash to a 6-digit hexadecimal color code
        let color = (hash >>> 0).toString(16).slice(-6);

        // Pad the color code with zeros if necessary
        while (color.length < 6) {
            color = "0" + color;
        }

        return "#" + color;
    } else {
        return "#000";
    }
}

export const shareItem = async (link1, image, message1, name = "") => {
    const downloadPath = "";
    // const downloadPath = `${RNFS.CachesDirectoryPath}/tempImage.jpg`;
    // await RNFS.downloadFile({
    //   fromUrl: image,
    //   toFile: downloadPath,
    // }).promise;

    // Read the image file and convert it to base64
    // const base64 = await RNFS.readFile(downloadPath, 'base64');
    // const link = await dynamicLinks().buildShortLink({
    //   link: link1,
    //   ios: {
    //     bundleId: BUNDLEID,
    //     appStoreId: APPSTOREID,
    //   },
    //   otherPlatform: {
    //     fallbackUrl: FALLBACK_URL,
    //   },
    //   domainUriPrefix: DOMAINURIPREFIX,
    //   analytics: {
    //     campaign: "banner",
    //   },
    //   social: {
    //     title: name,
    //     descriptionText: message1,
    //     // imageUrl: `data:image/png;base64,${base64}`,
    //     imageUrl: image || "https://picsum.photos/id/1/200/300",
    //   },
    // });

    const linkMetadata = {
        title: name,
        message: message1,
        image: "https://picsum.photos/id/1/200/300",
        url: link,
    };

    // Share.open({
    //   // message: `*${name}*\n${message1}\n\nCheck it out here: ${link}`,
    //   // message: `*${name}*\n${message1}\n${link}`,
    //   url: link,
    //   // linkMetadata: linkMetadata,
    // })
    //   .then(() => {})
    //   .catch((err) => {
    //     console.warn("err", err);
    //   });
};

const handleGallery = async ({ height = 1500, width = 1200 }) => {
    // return ImageCropPicker.openPicker({
    //   width: width,
    //   height: height,
    //   cropping: true,
    //   includeBase64: true,
    //   smartAlbums: IMAGE_PICKER_SMART_ALBUMS,
    // })
    //   .then((img) => {
    //     return img;
    //   })
    //   .catch((err) => {
    //     if (err.message === "User did not grant library permission.") {
    //       Alert.alert("Vêtir", "Please provide access to photos", [
    //         {
    //           text: "Cancel",
    //           onPress: () => {},
    //           style: "cancel",
    //         },
    //         {
    //           text: "OK",
    //           onPress: () => {
    //             Linking.openSettings();
    //           },
    //         },
    //       ]);
    //     }
    //     return null;
    //     console.log("err", err.message);
    //   });
};

const handleCamera = async ({ height = 1500, width = 1200 }) => {
    // return ImagePicker.openCamera({
    //   width: width,
    //   height: height,
    //   cropping: true,
    //   includeBase64: true,
    //   smartAlbums: IMAGE_PICKER_SMART_ALBUMS,
    // })
    //   .then(img => {
    //     return img;
    //   })
    //   .catch(err => {
    //     if (err.message === 'User did not grant camera permission.') {
    //       Alert.alert('Vêtir', 'Please provide access to camera', [
    //         {
    //           text: 'Cancel',
    //           onPress: () => {},
    //           style: 'cancel',
    //         },
    //         {
    //           text: 'OK',
    //           onPress: () => {
    //             Linking.openSettings();
    //           },
    //         },
    //       ]);
    //     }
    //     return null;
    //   });
};

const expandDiacritics = (keyword) => {
    const escapeRegExp = (str) => str?.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    return (
        escapeRegExp(keyword)
            ?.replace(/a/gi, "[aáàâäãå]")
            ?.replace(/e/gi, "[eéèêë]")
            ?.replace(/i/gi, "[iíìîï]")
            ?.replace(/o/gi, "[oóòôöõø]")
            ?.replace(/u/gi, "[uúùûüů]")
            ?.replace(/c/gi, "[cç]")
            ?.replace(/n/gi, "[nñ]") || ""
    );
};

function removeDiacritics(str) {
    return str?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "") || "";
}

function isDigit(char) {
    return char >= "0" && char <= "9";
}

export {
    getFormatedDate,
    getChartValueFromArr,
    getFilterParamsV2,
    getFormatedCurrency,
    removeObjectWithId,
    stringToColor,
    getOrderHistoryCardView,
    getOrderHistoryCardBottomView,
    handleCamera,
    handleGallery,
    expandDiacritics,
    removeDiacritics,
    isDigit,
    getFilterUrlParams,
    getFilterParamsAPIV2,
    checkSelectedFilters,
};
